// custom-actions.service.ts
import {inject, Injectable} from '@angular/core';
import {HttpHeaders} from "@angular/common/http";
import {HttpClient} from "@angular/common/http";
import {AuthenticationService, NotificationService} from "@alfresco/adf-core";

// @ts-ignore
import { AppStore } from '@alfresco/aca-shared/store';
import { AppSettingsService } from '@alfresco/aca-shared';
import {Store} from '@ngrx/store';
import { algAuthorizationHeader } from '../src/lib/alg-auth';

@Injectable({
  providedIn: 'root'
})
export class MailToSharedService {

  protected store = inject<Store<AppStore>>(Store<AppStore>);
  protected baseShareUrl: string;

  constructor(private appSettingsService: AppSettingsService,
              private http: HttpClient,
              private authService: AuthenticationService,
              private notificationService: NotificationService) {  }


  mailToShared(node: any) {
    let shareUrl = node.properties['qshare:sharedId'];

    if (!shareUrl) {
      this.shareNode(node);
    } else {
      this.launchMailTo(node, shareUrl);
    }
  }

  //create link if not shared yet
  shareNode(node: any) {
      let data = {
        "nodeId": node.id,
      }

      const endpointUrl = window.location.origin + `/alfresco/api/-default-/public/alfresco/versions/1/shared-links`;
      let headers = new HttpHeaders();
      let auth = algAuthorizationHeader(this.authService);
      // @ts-ignore
      headers = headers.append('Authorization', auth);

      this.http.post(endpointUrl, data, {headers: headers}).subscribe(
          res => {
            let url = res['entry']['id'];
            this.launchMailTo(node, url);
            },
          () => {
              this.notificationService.showError('Une erreur est survenue lors de la mise en partage');
          });
    }

    launchMailTo(node: any, url: string) {
      // ACA 6.0.0 a supprime le selecteur getSharedUrl du store : l'URL de partage se lit
      // desormais directement sur AppSettingsService, comme le fait ContentManagementService.
      this.baseShareUrl = this.appSettingsService.baseShareUrl;
      if (url){
        let mailto = 'mailto:?subject=' + node.name + '&body=' + this.baseShareUrl + url;
        // Ouvrir dans un nouvel onglet
        window.open(mailto, '_blank');
      }
    }

}
